
<div id="generic-action-control-view">
    <span tabindex="0" class="link" role="button" (click)="triggerViewAction()" style="margin:auto">
      {{ 'ACCOUNTS_MODULE.accountList.view' | translate }}
    </span>
</div>
